import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import MediaRequests from "services/media";
import GalleryElement from "./GalleryElement";
import GridContainer from "@jumbo/components/GridContainer";
import { Box, Grid } from "@material-ui/core";
import Pagination from "@material-ui/lab/Pagination";
import { animateScroll as scroll } from "react-scroll";

const AllEventGalleries = () => {
  const { allGalleries, galleryCurrentPage, galleryTotalPages } = useSelector(
    ({ media }) => media
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(MediaRequests.getAllGalleies(1));
  }, []);

  const handleChangePagination = (_, value) => {
    dispatch(MediaRequests.getAllGalleies(value));
    scroll.scrollToTop();
  };

  return (
    <>
      <GridContainer>
        <Grid item xs={12}>
          {allGalleries &&
            allGalleries.map((gallery) => (
              <GalleryElement key={gallery._id} gallery={gallery} />
            ))}
        </Grid>
      </GridContainer>
      <Box display={"flex"} justifyContent={"center"} marginTop={"20px"}>
        <Pagination
          count={galleryTotalPages}
          color="primary"
          page={galleryCurrentPage}
          onChange={handleChangePagination}
        />
      </Box>
    </>
  );
};

export default AllEventGalleries;
